import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { NihlOutlineExposureService } from 'src/app/services/nihl-outline-exposure.service';
import * as moment from 'moment';
import { IkTableData, KTableGridService } from 'ng-k-data-visualization';
import { ClaimsService } from 'src/app/services/claims.service';
import { KIconType } from 'ng-k-icon';
import { UrlService } from 'src/app/services/url.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';

@Component({
  selector: 'app-outline-exposure-listing',
  templateUrl: './outline-exposure-listing.component.html',
  styleUrls: ['./outline-exposure-listing.component.scss']
})
export class OutlineExposureListingComponent implements OnInit {
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public claimId: any;
  public taskId: any;
  public showStage1: boolean = true;

  public sampleData = [];
  public data: any = [];
  public tableData!: IkTableData;
  public maxSize = 8;

  public currentExposureId: any = '';
  public currentEmployerData = [];
  public currentEmployerName = ''
  public outlineExposureForm: any =  {};
  public notionalExposureList: {label: string, value: any}[] = [];
  public isSubmitted = false;
  public successText!: string;
  public errorText!: string;
  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public timeout!: number;
  public customData: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _auth: OauthPlusService,
    private loaderService: GlobalLoadingService,
    private claimsService: ClaimsService,
    private nihlOutlineExposureService: NihlOutlineExposureService,
    public kTableGridService: KTableGridService,
    private urlService: UrlService,
    private modalService: NgbModal,
    private fb: FormBuilder,
  ) { 
    this.outlineExposureForm = fb.group({
    notionalExposure: ['', Validators.required]
  });
}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (!this.isUrlEncoded(params['claimId'])) {
        this.claimId = decodeURIComponent(params['claimId']);
      } else {
        this.claimId = params['claimId'];
      }
  
      if (!this.isUrlEncoded(params['taskId'])) {
        this.taskId = decodeURIComponent(params['taskId']);
      } else {
        this.taskId = params['taskId'];
      }
    });

    this._auth.$whenUserLoaded.subscribe(data=> {
      if(data) {
        this.getExposureList();
      }
    });

    this.getWorkflowOverview(this.claimId);
  }

  public isUrlEncoded(str: string): boolean {
    try {
      return str !== decodeURIComponent(str);
    } catch (e) {
      return false;
    }
  }

  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');

        this.customData = {
          claimId : this.claimId,
          taskId : this.taskId, 
          claimantName : result.data.meta.claimant.claimantName,
          medicalConditionLabel: 'NIHL',
          medicalConditionValue: 'nihl'
        };
      }
    },
      err => {
        console.log(err.error);
      });
  }

  public getExposureList() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.urlService.fullyDecodeURI(this.claimId) : null;
    requestParam.taskId = this.taskId? this.urlService.fullyDecodeURI(this.taskId) : null;
    requestParam.actionName = 'exposure_view_all';
    requestParam.payload = {};


    this.loaderService.startLoadingIndicator('getExposureList');
    thisObj.nihlOutlineExposureService.getExposureList(requestParam).subscribe((result: { status: string; data: any; }) => {
      if (result.status === 'Success') {
        this.initiateTable(result.data);
        this.loaderService.stopLoadingIndicator('getExposureList');
      }  
    },
      (    err: { error: any; }) => {
      console.log('err')
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getExposureList');
    }); 
  }

  initiateTable(tableData: any) {
    this.sampleData = [];
    this.data = [];
      this.sampleData = tableData;
      // console.log(this.sampleData)
    
      if (this.sampleData.length > 0) {
        
        for (const data of this.sampleData) {
          const temp = [
            {
              label: data['_id'],
              isShow: false
            },
            {
              label: data['employer']['employer'],
            },
            {
              label: data['notionalExposure'],
            },
            {
              label: '',
              icons: [
                {
                  type: KIconType.fas,
                  name: 'edit',
                  action: 'edit',
                  tooltipText: 'Edit',
                  id: data['_id']
                }
              ],
              align: 'left'
            }
          ];
          this.data.push(temp);
          
        }
      } else {
        const temp = [
          {
            label: 'No data found.',
            colspan: 12
          },
        ];
        this.data.push(temp);
        
      }
      
      this.tableDataInitialisation();
  }

  async tableDataInitialisation() {
    this.tableData = {
      header: [
        {
          label: 'Employer',
        },
        {
          label: 'Notional Exposure',
        },
        {
          label: 'Action'
        }
      ],
      isStaticData: true,
      data: this.data,
      isTableResponsive: true,
      rowStripedColour: 'brand-main',
      isSearchTextFilter: false,
      checkboxConfig: {
        isShow: false,
        colour: 'dark-grey'
      }
    };
    if (this.sampleData.length > 0) {
      this.tableData.pagination = {
        maxSize: this.maxSize,
        totalRows: this.sampleData.length,
        align: 'end',
      }
    }
    if (this.tableData.isStaticData) {
      this.kTableGridService.pushData(this.tableData);
    }
  }

  completeNIHLExposure() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.claimId : null;
    requestParam.taskId = this.taskId? this.taskId : null;
    this.loaderService.startLoadingIndicator('completeNIHLExposure');
    thisObj.nihlOutlineExposureService.taskFulfill(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('completeNIHLExposure');
        this.getWorkflowFulfill(this.claimId);
      }  
    },
      (    err: { error: any; }) => {
      console.log('err')
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('completeNIHLExposure');
    }); 
  } 

  public getWorkflowFulfill(claimId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId? claimId : null;
    this.loaderService.startLoadingIndicator('getWorkflowFulfill');
    thisObj.claimsService.getWorkflowFulfill(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowFulfill');
        this.router.navigate(['/claimDetail/',(this.claimId)]);
      }
    }); 
  }

  goToPage() {
    this.router.navigate(['/claimDetail/',this.claimId]);
  }

  addNewExposure() {
    this.router.navigate(['nihl/investigation/outline-exposure/add/',this.claimId,this.taskId])
  }

  getTableData(event: any, template: any) {
    let actionType = (event.action);
    if (actionType === 'delete') {
    } else 
    if (actionType === 'edit') {
      this.currentExposureId = event.data[0].label;
      // console.log(this.currentExposureId)
      this.notionalExposureDropdownList()
      this.getExposureById()
      this.open(template)
      // this.router.navigate(['nihl/investigation/outline-exposure/edit/',this.claimId,this.taskId,this.currentExposureId])
     
    }
  }

  public open(content: any) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, windowClass: ' audiometryResult_mdl'  }) .result.then((result) => {
    
    }, (reason) => {
      
    });
  }

  public notionalExposureDropdownList() {
    let tempList = ['Clinical Medico-legal','Defendant Medico-legal','Occupational Hygiene', 'Hospital'];
    for(let i=85;i<126;i++) {
      this.notionalExposureList.push({label: ''+i, value: i });
    }
  }

  public getExposureById() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.claimId : null;
    requestParam.taskId = this.taskId? this.taskId : null;
    requestParam.actionName = 'exposure_view_by_id';
    requestParam.payload = {
      "id":this.currentExposureId
    };
    this.loaderService.startLoadingIndicator('getExposureById');
    thisObj.nihlOutlineExposureService.getExposureList(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getExposureById');
        this.currentEmployerName = result.data[0].employer.employer;
        this.currentEmployerData = result.data[0].employer;
        this.outlineExposureForm.patchValue({
          notionalExposure: result.data[0].notionalExposure
        });
      }
    });
}

 /**
   * convenience getter for easy access to form fields
   */
 get f() { 
  return this.outlineExposureForm.controls; 
}

public updateNotionalExposure(form: any) {
  this.saveOutlineExposureForm(form)
}

public saveOutlineExposureForm(form: any) {
  this.isSubmitted = true;
  if(form.status == 'VALID'){
    const thisObj = this;
    const requestParam: any = {};
    this.loaderService.startLoadingIndicator('saveOutlineExposureForm');
    requestParam.claimId = this.claimId? this.claimId : null;
    requestParam.taskId = this.taskId? this.taskId : null;
    if (this.currentExposureId) {
      requestParam.actionName = 'edit_nihl_exposure';
      requestParam.payload = {
        "id" : this.currentExposureId,
        "employer" : this.currentEmployerData,
        "notionalExposure": form.controls.notionalExposure.value,
      };
    }

    thisObj.claimsService.postWorkflowActivity(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('saveOutlineExposureForm');
        if (result.data.isValid) {
          if (this.currentExposureId != '')
          { 
            this.successText = 'Exposure edited successfully';
          } else {
            this.successText = 'Exposure added successfully';
          }
          this.showMessage('success', 2000);
          this.modalService.dismissAll();
          this.getExposureList();
          // setTimeout(() => {
          //   this.router.navigate(['nihl/investigation/outline-exposure',this.claimId, this.taskId])
          // },2020);
        } else {
          this.errorText = result.data.errors;
          this.showMessage('error', 2000);
        }          
      }
    }); 
  }
}

public showMessage(msgType: any, timeout: any) {
  this.displaySuccess = false;
  this.displaySuccess = false;
  if ( msgType === 'success' ) {
    this.displaySuccess = true;
  }
  if ( msgType === 'error') {
    this.displayError = true;
  }
  if ( timeout ) {
    this.timeout = timeout;
  }
}

}
